import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider} from 'react-redux'
import { setupStore } from './store';
import { captureLeadAttribution } from './utils/leadAttribution';
import { notifyAdVisit } from './utils/adVisitNotification';

captureLeadAttribution();
void notifyAdVisit();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const store = setupStore()

root.render(
  <Provider store={store}>
    <App />
  </Provider>
    
);

